// import projectOne from '../../images/cover.jpg'
import saber from '../../images/saber.png'
import superBlog from '../../images/dashboard.png'
import sprint from '../../images/sprint.png'
import laker from '../../images/laker.png'
import blog from '../../images/blog.png'
import instaclone from '../../images/instaclone.png'
import delivery from '../../images/delivery.png'
import deliveryguy from '../../images/deliveryguy.png'
import arvest from '../../images/arvest.png'
import arvestdash from '../../images/arvestdash.png'
import mernBlog from '../../images/mernBlog.png'
import book from '../../images/book.png'
import amad from '../../images/amad.png'
import lathy from '../../images/lathy.png'
import ngo from '../../images/ngo.png'
import scolaza from '../../images/scolaza.png'
import SEO from '../../images/SEO.png'
import netschool from '../../images/netschool.png'
import portfolio from '../../images/portfolio.png'
import ambulance from '../../images/ambulance.png'
import viberr from '../../images/viberr.png'
import amad1 from '../../images/amad1.png'
import mamakitchen from '../../images/mamakitchen.png'
import mamadash from '../../images/mamadash.png'
import vueMovie from '../../images/vueMovie.png'
import reactMovies from '../../images/reactMovies.png'
import reactStore from '../../images/reactStore.png'
import storeJS from '../../images/storeJS.png'
import gitReact from '../../images/gitReact.png'
import family from '../../images/family.png'

export const projectData =[
    {
        id:1,
        title:"Saber Fleet Management",
        about:"This system responsible for planning, directing, managing, coordinating and supervising the programs for acquisition, assignment, utilization, maintenance, repair, replacement and disposal of fleet vehicles.",
        tags:["ReactJS","NodeJS","MysQl","JavaScript"],
        demo:"https://sb.rafahgroup.com/",
        github:"https://github.com/FREDVUNI/saber",
        image:saber
    },
    {
        id:2,
        title:"The delivery guy Ug Admin console",
        about:"The Delivery Guy Ug a start up courier service provider that specializes in last mile delivery solutions facilitating express and regular deliveries of parcels, packages & goods from businesses to their partners and recipients.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        demo:"https://deliveryguyug.com/",
        github:"",
        image:deliveryguy
    },
    {
        id:3,
        title:"Arvest Ug",
        about:"Arvest Ug is an online platform for AgroEconomists. Our goal is to improve lives through agriculture. The rapid increase in populataion automatically indicates a high demand for food, Arvest Ug is here to bridge that gap among the Farmers, Agriculture vendors, companies, manufactures, Engineers and Government agencies thus improving the food industry.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        demo:"https://www.arvestug.com",
        github:"https://github.com/FREDVUNI/arvestug",
        image:arvest
    },
    {
        id:4,
        title:"Viberr music site",
        about:"Viberr is an online platform for music albums. Its main purpose is to show how to use django and bootstrap to show available albums, artists and listeners' favorite music using sqlite as the database .",
        tags:["Django","Bootstrap","SQLite 3","Python"],
        demo:"#",
        github:"https://github.com/FREDVUNI/django-music-blog",
        image:viberr
    },
    {
        id:5,
        title:"Vue Js movie search App",
        about:"A vue js movie app that shows searched movies from the omdbapi which enables search for tons of movies.",
        tags:["Vue JS","Bootstrap","omdbapi","JavaScript"],
        demo:"https://vue-js-movie-app.netlify.app/",
        github:"https://github.com/FREDVUNI/vuejs-movie-app",
        image:vueMovie
    },
    {
        id:6,
        title:"Arvest Ug Admin console",
        about:"Arvest Ug is an online platform for AgroEconomists. Our goal is to improve lives through agriculture. The rapid increase in populataion automatically indicates a high demand for food, Arvest Ug is here to bridge that gap among the Farmers, Agriculture vendors, companies, manufactures, Engineers and Government agencies thus improving the food industry.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        demo:"http://console.arvestug.com/",
        github:"https://github.com/FREDVUNI/arvest",
        image:arvestdash
    },
    {
        id:7,
        title:"M.E.R.N Blog",
        about:"This is a a blog developed using the M.E.R.N stack. It shows how a blog works.The frontend was developed in react and the backend in node js (separately)",
        tags:["ReactJS","NodeJS","MongoDB"],
        demo:"",
        github:"https://github.com/FREDVUNI/reactBlog",
        image:mernBlog
    },
    {
        id:8,
        title:"NodeJS Book store",
        about:"This is a book developed using node JS (express JS) and ejs. It shows the entire CRUD process.",
        tags:["NodeJS","Bootstrap","JQuery","MongoDB"],
        demo:"",
        github:"https://github.com/FREDVUNI/Bookstore",
        image:book
    },
    {
        id:9,
        title:"The Delivery guy ug",
        about:"The Delivery Guy Ug a start up courier service provider that specializes in last mile delivery solutions facilitating express and regular deliveries of parcels, packages & goods from businesses to their partners and recipients.",
        tags:["HTML","CSS","Bootstrap","Javascript","JQuery"],
        demo:"http://thedeliveryguyug.com/",
        github:"https://github.com/FREDVUNI/delivery-guy-ug",
        image:delivery
    },
    {
        id:10,
        title:"Instagram clone",
        about:"This is an instagram clone that gives you a view of how instagram works.An Instagram Clone using Laravel .Instagram clone application developed using Laravel Framework.",
        tags:["VueJS","PHP","Laravel","MysQl"],
        demo:"",
        github:"https://github.com/FREDVUNI/instagram-clone",
        image:instaclone
    },
    {
        id:11,
        title:"Laravel 8 Blog",
        about:"This is a blog that shows different posts,specific posts and allows users to register,login and create posts.",
        tags:["PHP","Laravel","MysQl"],
        demo:"",
        github:"https://github.com/FREDVUNI/laravelblog",
        image:blog
    },
    {
        id:12,
        title:"SuperBlog dashboard",
        about:"This is a laravel 8 and vue js dashboard that shows how the two can be used to create an admin dashboard.",
        tags:["VueJS","PHP","Laravel","MysQl"],
        demo:"",
        github:"https://github.com/FREDVUNI/larastart",
        image:superBlog
    },
    {
        id:13,
        title:"Laker Consultants",
        about:"This is a consultancy that creates linkages between business and potential investment ventures.Laker consultants improve performance in terms of operations, profitability, management, structure and strategy.",
        tags:["HTML","CSS","Bootstrap","JQuery"],
        demo:"",
        github:"https://github.com/FREDVUNI/laker-consultants",
        image:laker
    },
    {
        id:14,
        title:"Sprint Uganda",
        about:"This is a Website for a company that provides connectivity solutions including Fiber Internet, Cloud storage and data hosting, VSAT solutions, leased line solutions, MPLS solutions, Social WiFi etc.",
        tags:["HTML","CSS","Bootstrap","JQuery"],
        demo:"",
        github:"https://github.com/FREDVUNI/sprintuganda",
        image:sprint
    },
    {
        id:15,
        title:"AMAD Ask me about Dubai dashboard",
        about:"An agency that provides travel and tourism-related services to the general public on behalf of accommodation or travel suppliers to offer different kinds of travelling packages for each destination in Dubai.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        demo:"",
        github:"https://github.com/FREDVUNI/amad",
        image:amad
    },
   {
        id:16,
        title:"AMAD Ask me about Dubai dashboard 2022",
        about:"An agency that provides travel and tourism-related services to the general public on behalf of accommodation or travel suppliers to offer different kinds of travelling packages for each destination in Dubai.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        demo:"",
        github:"https://github.com/FREDVUNI/amad",
        image:amad1
    },
    {
        id:17,
        title:"Scolaza Online stationery",
        about:"This is an online business that sells stationery. It spells from making an ecommerce store to giving a height to online buying and selling stationery.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        demo:"",
        github:"https://github.com/FREDVUNI/scolaza",
        image:scolaza
    },
    {
        id:18,
        title:"Laravel 8 Mama's Kitchen ",
        about:"This is a web application that enables users to submit their orders ,view the kitchen menu and also request for reservation via email.",
        tags:["PHP","Laravel","MysQl"],
        demo:"#",
        github:"https://github.com/FREDVUNI/mamas-kitchen",
        image:mamakitchen
    },
    {
        id:19,
        title:"Laravel 8 Mama's Kitchen dashboard",
        about:"This is a web application that enables users to change categories ,add admins,create sliders ... basically carry out the entire CRUD process with all the modules as seen in the picture.",
        tags:["PHP","Laravel","MysQl"],
        demo:"#",
        github:"https://github.com/FREDVUNI/mamas-kitchen",
        image:mamadash
    },
    {
        id:20,
        title:"Laravel 8 Vue Js ",
        about:"This is a web application that enables users to submit their website links to improve their search engine optimization",
        tags:["VueJS","PHP","Laravel","MysQl"],
        demo:"",
        github:"https://github.com/FREDVUNI/WebApp",
        image:SEO
    },
    {
        id:21,
        title:"Lathy Foundation Africa",
        about:"Lathy Foundation Africa is Non Government and non profit Organisation. It was founded by Nassali Caroline (CEO) on March 10th 2021. Its target is the vulverable groups of people for example pregnant women (pre and post), newborn babies, adoloscents, disabled and the aged. ",
        tags:["Codeigniter","Javascript","HTML","CSS","Bootstrap","JQuery"],
        demo:"http://lathyfoundationafrica.com/",
        github:"https://github.com/FREDVUNI/lathy",
        image:lathy
    },
    {
        id:22,
        title:"React NGO website",
        about:"This is a non-profit organization website that shows the activities of a non government organisation usually helping people in need using react styled components with dummy data",
        tags:["React","JavaScript"],
        demo:"https://react-ngo-app.netlify.app/",
        github:"https://github.com/FREDVUNI/react-ngo-app",
        image:ngo
    },
    {
        id:23,
        title:"Online school system",
        about:"This is an Online school with virtual classes that students can take from home or a library or a coffee shop or anywhere else that has an Internet connection. The teachers work remotely and have a structured curriculum for their online students to follow.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        demo:"",
        github:"https://github.com/FREDVUNI/netscchoolug",
        image:netschool
    },
    {
        id:24,
        title:"Developer Portfolio",
        about:"This is a website that showcases your best work, personality and talents. It is your best chance to prove your skills, share your enthusiasm about the profession and give your potential employers and clients a glimpse of how awesome it would be to work with you.",
        tags:["HTML","CSS","Bootstrap","JQuery"],
        demo:"",
        github:"https://github.com/FREDVUNI/portfolio",
        image:portfolio
    },
    {
        id:25,
        title:"React github app",
        about:"A React JS movie app that enables users to fetch/search usernames and their associated information and repositories from the github API",
        tags:["ReactJS","CSS","javaScript"],
        demo:"https://react-js-github.netlify.app/",
        github:"https://github.com/FREDVUNI/reactGithub",
        image:gitReact
    },
    {
        id:26,
        title:"React movie app",
        about:"A React JS movie app that enables users to fetch/search movies from an API",
        tags:["ReactJS","CSS","javaScript"],
        demo:"https://react-js-movies-app.netlify.app/",
        github:"https://github.com/FREDVUNI/reactjs-movie-app",
        image:reactMovies
    },
    {
        id:27,
        title:"Family SACCO",
        about:"This is a SACCO management system/dashboard that is payment tracker,member registry and sets payment dates.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        github:"https://github.com/FREDVUNI/family-sacco",
        image:family
    },
    {
        id:28,
        title:"JS Online Shop",
        about:"An online shop developed in HTML,CSS and JavaScript enabling user registration, login and shopping. All data is stored in the browser's local Storage.",
        tags:["HTML","CSS","JavaScript"],
        demo:"https://kanzucode-iconic.netlify.app/",
        github:"https://github.com/FREDVUNI/capstone-javascript",
        image:storeJS
    },
    {
        id:29,
        title:"Ambulance Africa dashboard",
        about:"A codeIgniter JQuery dashboard for ambulance Africa.",
        tags:["Codeigniter","PHP","MysQl","JavaScript","JQuery"],
        github:"https://github.com/FREDVUNI/ambulance-africa",
        image:ambulance
    },
    {
        id:30,
        title:"React online shop",
        about:"An online react JS shop enabling user registration, login and shopping. All data is stored in the browser's local Storage",
        tags:["ReactJS","CSS","javaScript"],
        demo:"https://iconic-store.netlify.app/",
        github:"https://github.com/Akareut/react-capstone",
        image:reactStore
    }
]